import { t } from 'localization'
import Head from 'next/head'
import Link from 'next/link'
import { Trans } from 'react-i18next'

import ShrinkWrappedJordan1Bred from 'notFound/ShrinkWrappedJordan1Bred'
import { colors, fonts, media, styles } from 'shared/lib'
import styled from 'styled-components'

const TP = 'errors.components.DefaultError'

export const DefaultError = () => {
  return (
    <DefaultError.Wrapper>
      <Head>
        <title>{t(`${TP}.title`, 'Sorry, something went wrong.')} | Flight Club</title>
      </Head>
      <TopBanner>
        <BannerMessage>
          <Header>{t(`${TP}.title`, 'Sorry, something went wrong.')}</Header>
          <Subtitle>
            <Trans
              i18nKey={`${TP}.body`}
              defaults="Please try again or reach out to <0>support@flightclub.com</0>"
              components={[<Link key="supportLink" href="mailto:support@flightclub.com" />]}
            />
          </Subtitle>
        </BannerMessage>
        <SneakerImage />
      </TopBanner>
    </DefaultError.Wrapper>
  )
}

const TopBanner = styled.div`
  background-color: ${colors.FC2_WHITE};
  display: flex;
  justify-content: center;
  flex-wrap: wrap-reverse;
  padding: ${styles.mobilePageLayoutPadding};
`

const BannerMessage = styled.div`
  max-width: 400px;
  display: flex;
  flex-direction: column;
  justify-content: center;
  margin: 20px 0 40px;
`

const Header = styled.h1`
  ${fonts.HEADER_1};
  font-weight: 500;
`

const Subtitle = styled.h2`
  ${fonts.BODY_TEXT};
  font-weight: unset;
`

const SneakerImage = styled(ShrinkWrappedJordan1Bred)`
  ${media.large`
    margin: 50px 20px;
  `}
`

DefaultError.Wrapper = styled.div`
  text-align: center;
`
